import { HttpResponse } from '@angular/common/http';

// extract filename in Response Header . Eg: "attachment; filename=\"approval-03052021-10052021.xlsx\""
export const getFileNameFromHttpResponse = (httpResponse: HttpResponse<any>, defaultName = 'file') => {
  const contentDispositionHeader = httpResponse.headers.get('Content-Disposition');
  let filename = defaultName;
  try {
    filename = contentDispositionHeader.split(';')[1].trim().split('=')[1];

    // remove the ""
    filename = filename.replace(/"/g, '');
  } catch (err) {
    console.log(err);
  }
  return filename;
};

// create a popup to save the file
// ref: https://stackoverflow.com/questions/35138424/how-do-i-download-a-file-with-angular2-or-greater
export const createDownloadPopup = (data: Blob, fileName = 'download_file', contentType: string = '') => {
  const blob = new Blob([data], { type: contentType });
  const url = window.URL.createObjectURL(blob);
  let downloadLink = document.createElement('a');
  downloadLink.href = url;
  downloadLink.setAttribute('download', fileName);
  document.body.appendChild(downloadLink);
  downloadLink.click();

  // notify browser to release the reference to the file
  setTimeout(() => {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(url);
    downloadLink.parentNode.removeChild(downloadLink);
  }, 100);
};
